"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayChunk = void 0;
const Reader_1 = require("../Reader");
class ReplayChunk {
    constructor(initialState, startTime) {
        this.state = initialState.clone();
        this.startTime = startTime;
        this.timeLength = 10;
        this.data = null;
        this.reader = null;
    }
    setData(data) {
        this.data = new Uint8Array(data.length);
        for (let i = 0; i < data.length; ++i) {
            this.data[i] = data[i];
        }
        this.reader = new Reader_1.Reader(this.data.buffer);
    }
}
exports.ReplayChunk = ReplayChunk;
